var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { datadogLogs } from '@datadog/browser-logs';
import { configuration } from '../../configuration';
import { Origin } from '../../enums';
import { sendLead } from '../../integrations/leads-api';
import { getTimezone, leadStoreGenerator, retrieveAccountOrigin, retrieveGCLID, retrieveUtm, sessionStorage, } from '../../utils';
var keyPrefix = configuration.sessionStorageKeyPrefix;
var keySuffixes = configuration.sessionStorageKeySuffixes;
var LendiGroupLeads = /** @class */ (function () {
    function LendiGroupLeads(leadOrigin) {
        this.storageKey = "".concat(keyPrefix, "-").concat(leadOrigin);
    }
    /**
     * set()
     *
     * @version: Used by LALA to identify this lead data is a lg lead as opposed to a legacy lead.
     * @timestamp: Used by this library to identify the latest lead that was set. (see retrieveLatestLeadData())
     *
     * @param payload
     */
    LendiGroupLeads.prototype.set = function (payload) {
        sessionStorage.set(this.storageKey, __assign(__assign({}, payload), { version: 'v3', timestamp: new Date().getTime() }));
    };
    LendiGroupLeads.prototype.get = function () {
        return sessionStorage.get(this.storageKey) || {};
    };
    Object.defineProperty(LendiGroupLeads, "firstName", {
        get: function () {
            return sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.firstName));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setFirstName = function (firstName) {
        sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.firstName), firstName);
    };
    Object.defineProperty(LendiGroupLeads, "email", {
        get: function () {
            return sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.email));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setEmail = function (email) {
        sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.email), email);
    };
    Object.defineProperty(LendiGroupLeads, "mobileNumber", {
        get: function () {
            return sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.mobileNumber));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setMobileNumber = function (mobileNumber) {
        sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.mobileNumber), mobileNumber);
    };
    Object.defineProperty(LendiGroupLeads, "storeId", {
        /**
         * storeId()
         *
         * Used to get the store id set by broker & store pages for Aussie leads.
         */
        get: function () {
            return sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.storeId));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * setStoreId()
     *
     * Used to set a store id by broker & store pages for Aussie leads.
     */
    LendiGroupLeads.setStoreId = function (storeId) {
        sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.storeId), storeId);
    };
    /**
     * unsetStoreId()
     *
     * Used to unset a store id set by store pages for Aussie leads.
     */
    LendiGroupLeads.unsetStoreId = function () {
        sessionStorage.remove("".concat(keyPrefix, "-").concat(keySuffixes.storeId));
    };
    Object.defineProperty(LendiGroupLeads, "brokerId", {
        /**
         * brokerId()
         *
         * Set by broker & store pages for Aussie leads.
         */
        get: function () {
            return sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.brokerId));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * unsetBrokerId()
     *
     * Used to unset a broker id set by broker pages for Aussie leads.
     */
    LendiGroupLeads.unsetBrokerId = function () {
        sessionStorage.remove("".concat(keyPrefix, "-").concat(keySuffixes.brokerId));
    };
    /**
     * setBrokerId()
     *
     * Set by broker & store pages for Aussie leads.
     */
    LendiGroupLeads.setBrokerId = function (brokerId) {
        sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.brokerId), brokerId);
    };
    LendiGroupLeads.getAllStoredLeads = function () {
        var results = [];
        var leadOrigins = Object.keys(leadStoreGenerator());
        leadOrigins.forEach(function (origin) {
            var data = sessionStorage.get("".concat(configuration.sessionStorageKeyPrefix, "-").concat(origin));
            if (data)
                results.push({ data: data, funnelName: origin });
        });
        return results;
    };
    /**
     * retrieveLatestLeadData()
     *
     * Finds the latest stored lead data in sessionStorage
     * by timestamp.
     */
    LendiGroupLeads.retrieveLatestLeadData = function () {
        var defaultLead = {
            funnelName: Origin.SignUp,
            data: { timestamp: 0, version: 'v3' },
        };
        try {
            var leads = this.getAllStoredLeads();
            return leads.reduce(function (acc, funnelData) {
                var _b, _c;
                try {
                    if (((_b = acc === null || acc === void 0 ? void 0 : acc.data) === null || _b === void 0 ? void 0 : _b.timestamp) === undefined || ((_c = funnelData === null || funnelData === void 0 ? void 0 : funnelData.data) === null || _c === void 0 ? void 0 : _c.timestamp) === undefined)
                        return acc;
                    var isLatestLead = acc.data.timestamp < funnelData.data.timestamp;
                    return isLatestLead ? funnelData : acc;
                }
                catch (_d) {
                    return acc;
                }
            }, defaultLead);
        }
        catch (error) {
            datadogLogs.logger.error("An error occurred while retrieve latest lead data.", {}, error);
            return defaultLead;
        }
    };
    var _a;
    _a = LendiGroupLeads;
    /**
     * constructLeadsServicePayload()
     *
     * Used to construct lead data and obtain any additional
     * properties and add them to the lead object before sending
     * the lead data to the leads service.
     *
     * It also deletes properties that are specifically applied by the
     * lendigroup-leads-library (timestamp & version).
     *
     * @param leadData
     */
    LendiGroupLeads.constructLeadsServicePayload = function (leadData) {
        var _b;
        var leadOrigin = leadData.origin || Origin.SignUp;
        var shouldRetrieveBrokerStorePageData = configuration.brokerStorePageLeadJourneys.includes(leadOrigin);
        var leadAccountOrigin = leadData.accountOrigin || retrieveAccountOrigin(leadData);
        var leadStoreId = leadData.storeId || (shouldRetrieveBrokerStorePageData && LendiGroupLeads.storeId);
        var leadOwnerId = (shouldRetrieveBrokerStorePageData && LendiGroupLeads.brokerId) || leadData.ownerId;
        var leadMobileNumber = leadData.mobileNumber || LendiGroupLeads.mobileNumber;
        var leadEmail = leadData.email || LendiGroupLeads.email;
        var leadFirstName = leadData.firstName || LendiGroupLeads.firstName;
        var leadGeneratedAt = new Date().toISOString();
        // If an application has already set valid lead data for a lead, use that instead of retrieving.
        var leadUtm = ((_b = leadData === null || leadData === void 0 ? void 0 : leadData.utm) === null || _b === void 0 ? void 0 : _b.utmSource) ? leadData === null || leadData === void 0 ? void 0 : leadData.utm : retrieveUtm(leadData.accountOrigin);
        var leadGclId = retrieveGCLID(leadData.accountOrigin);
        var leadTimezone = leadData.timeZone || getTimezone();
        var lead = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, leadData), { 
            // Required properties
            mobileNumber: leadMobileNumber, origin: leadOrigin, accountOrigin: leadAccountOrigin, generatedAt: leadGeneratedAt, timeZone: leadTimezone }), (leadData.data && { data: leadData.data })), (leadFirstName && { firstName: leadFirstName })), (leadEmail && { email: leadEmail })), (leadStoreId && { storeId: leadStoreId })), (leadOwnerId && { ownerId: leadOwnerId })), (leadUtm && { utm: leadUtm })), (leadGclId && { gclId: leadGclId }));
        // Cleanup properties set by lendigroup-leads-library
        if ('timestamp' in lead)
            delete lead.timestamp;
        if ('version' in lead)
            delete lead.version;
        return lead;
    };
    /**
     * sendLatestLead()
     *
     * @param baseURL
     * @param additionalLeadProperties
     * @usage
     *
     * import { LendiGroupLeads } from 'lendigroup-leads-library'
     *
     * LendiGroupLeads.sendLatestLead(baseURL, additionalLeadData)
     */
    LendiGroupLeads.sendLatestLead = function (baseURL, additionalLeadProperties) { return __awaiter(void 0, void 0, void 0, function () {
        var leadFunnelObject, leadFunnelOrigin, leadFunnelData, error_1;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    leadFunnelObject = this.retrieveLatestLeadData();
                    leadFunnelOrigin = leadFunnelObject.funnelName;
                    leadFunnelData = leadFunnelObject.data;
                    return [4 /*yield*/, sendLead(baseURL, this.constructLeadsServicePayload(__assign(__assign(__assign({}, leadFunnelData), additionalLeadProperties), { origin: leadFunnelOrigin })))];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    error_1 = _b.sent();
                    datadogLogs.logger.error('An error occurred while sending a lead.', {}, error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * sendRawLead()
     *
     * Used to send a raw lead to leads v3 API. This lead
     * data will still be validated inside sendLead().
     *
     * @param baseURL
     * @param rawLeadData
     * @usage
     *
     * import { LendiGroupLeads } from 'lendigroup-leads-library'
     *
     * LendiGroupLeads.sendRawLead(baseURL, rawLeadData)
     */
    LendiGroupLeads.sendRawLead = function (baseURL, rawLeadData) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendLead(baseURL, rawLeadData)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    error_2 = _b.sent();
                    datadogLogs.logger.error("An error occurred while sending a raw lead.", {}, error_2);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return LendiGroupLeads;
}());
export { LendiGroupLeads };
//# sourceMappingURL=index.js.map